import React from 'react'
import styles from './Card.module.scss'

const Card = ({ children, padding = 'md', interactive = false, className = '', ...rest }) => (
  <div
    className={[
      styles.card,
      styles[`p_${padding}`],
      interactive ? styles.interactive : '',
      className,
    ].filter(Boolean).join(' ')}
    {...rest}
  >
    {children}
  </div>
)

const CardHeader = ({ title, subtitle, actions, className = '' }) => (
  <div className={`${styles.cardHeader} ${className}`}>
    <div className={styles.cardTitleBlock}>
      {title && <h3 className={styles.cardTitle}>{title}</h3>}
      {subtitle && <p className={styles.cardSubtitle}>{subtitle}</p>}
    </div>
    {actions && <div className={styles.cardActions}>{actions}</div>}
  </div>
)

const CardBody = ({ children, className = '' }) => (
  <div className={`${styles.cardBody} ${className}`}>{children}</div>
)

const CardFooter = ({ children, className = '' }) => (
  <div className={`${styles.cardFooter} ${className}`}>{children}</div>
)

Card.Header = CardHeader
Card.Body = CardBody
Card.Footer = CardFooter

export default Card
